import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { translations } from "@/i18n/translations";

const LanguageContext = createContext(null);

const STORAGE_KEY = "hc_lang";

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(null); // null = gate not passed yet
  const [ready, setReady] = useState(false);

  useEffect(() => {
    try {
      const saved = localStorage.getItem(STORAGE_KEY);
      if (saved === "en" || saved === "es") {
        setLangState(saved);
        document.documentElement.lang = saved;
      }
    } catch (_err) {
      // localStorage may be blocked; ignore
    }
    setReady(true);
  }, []);

  const setLang = (next) => {
    if (next !== "en" && next !== "es") return;
    try {
      localStorage.setItem(STORAGE_KEY, next);
    } catch (_err) {
      // ignore storage errors
    }
    setLangState(next);
    if (typeof document !== "undefined") {
      document.documentElement.lang = next;
    }
  };

  const toggleLang = () => setLang(lang === "es" ? "en" : "es");

  const value = useMemo(() => {
    const safeLang = lang || "en";
    return {
      lang,
      ready,
      t: translations[safeLang],
      setLang,
      toggleLang,
    };
  }, [lang, ready]);

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLanguage must be used within LanguageProvider");
  return ctx;
}
